import React from 'react';

import { Bar, Cta, Label } from './MobileCta.styles';

export interface MobileCtaProps {
  /** Button copy (i18n key / literal). */
  label: string;
  placeholders?: Record<string, string | number>;
  onClick: () => void;
  disabled?: boolean;
  /** Success-green fill (the final "Take your website live" go-live CTA). */
  green?: boolean;
  /** Non-interactive WITHOUT the disabled grey (e.g. while the intro morph plays
   *  over it) — keeps the active fill so the cross-fade stays orange→orange. */
  locked?: boolean;
}

/**
 * Shared mobile CTA — a full-width pill (radius 9999) pinned to a fixed bottom
 * offset. Used by the intro, the per-step chrome AND the step-4 go-live review so
 * the button sits at the EXACT same position on every screen. Orange by default;
 * `green` for the final go-live CTA.
 */
export const MobileCta = ({
  label,
  placeholders,
  onClick,
  disabled = false,
  green = false,
  locked = false,
}: MobileCtaProps): React.ReactElement => (
  <Bar>
    <Cta
      type="button"
      $enabled={!disabled}
      $green={green}
      $locked={locked}
      disabled={disabled}
      onClick={disabled || locked ? undefined : onClick}
    >
      {/* key on the copy so a step change remounts the label and replays its
          fade-in, cross-fading the wording instead of hard-swapping it. */}
      <Label key={label} text={label} placeholders={placeholders} tag="span" />
    </Cta>
  </Bar>
);

export default MobileCta;